export default __webpack_public_path__ + "static/media/calendar-component-spec.7fc25bbe.png";